import React from 'react';
import { Editor } from '@meitu/saas-editor-core';

interface ISelectImageModalProps {
    visible: boolean;
    isReplace?: boolean;
    originalImage?: string;
    setVisible?: (visible: boolean) => void;
    showSelectTool?: boolean;
    hiddenAIPhotoEntry?: boolean;
    selectCallback?: Function;
    closeCallback?: Function;
    changeNameCallback?: Function;
    addMaterialCallback?: (image: any, data?: any) => void;
    localMultiple?: boolean;
    editor: Editor;
    showAIPhoto?: boolean;
}

const SelectImageModal: React.FC<ISelectImageModalProps> = ({
    visible,
    isReplace,
    originalImage,
    setVisible,
    addMaterialCallback,
    closeCallback = () => {},
    showSelectTool = false,
    hiddenAIPhotoEntry,
    localMultiple = true,
    showAIPhoto = true,
    editor,
}) => {
    return <div>123</div>;
};
export default React.memo(SelectImageModal);
